import { Box, styled } from '@mui/material';
var StyledModalContentContainer = styled(Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'adminModal';
  }
})(function (_ref) {
  var theme = _ref.theme,
      adminModal = _ref.adminModal;
  var styles = {
    marginTop: adminModal ? '0' : theme.spacing(2.5)
  };
  return styles;
});
export { StyledModalContentContainer };